<template>
  <section
    id="recent-projects"
    class="overflow-hidden"
  >
    <v-row no-gutters>
      <v-col
        class="primary text-center pa-5 white--text"
        cols="12"
        md="6"
      >
        <base-bubble-1
          style="transform: rotate(180deg) translateX(25%)"
        />

        <base-heading>
          Recent Projects
        </base-heading>

        <base-text class="mb-5">
          My completed and ongoing projects.<br>
        </base-text>

        <v-card color="secondary">
          <v-container class="pa-2">
            <v-row>
              <v-col
                v-for="project in projects"
                :key="project.id"
                cols="12"
                md="6"
              >
              <v-hover v-slot="{ hover }">
                <a
                :href="`${project.link}`"
                target="_blank"
                >
                  <v-img
                    :src="project.src"
                    max-height="300"
                  >
                  <v-expand-transition>
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
            style="height: 100%;"
          >
          <base-text>
          {{project.desc}}
          </base-text>
          </div>
        </v-expand-transition>
                  </v-img>
                </a>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/recentprojects.jpg')"
          height="100%"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
  export default {
    name: 'RecentProjects',

    data: () => ({
      projects: [
        {
          id: 1,
          link: 'https://github.com/giwi97/book4book-front',
          src: require('@/assets/project1.jpg'),
          desc: 'Redesigned book exchanging platform for book4book.lk',
        },
        {
          id: 2,
          link: 'https://github.com/giwi97/teamDeltaProjectVII',
          src: require('@/assets/project2.jpg'),
          desc: 'MobiDine - Food ordering mobile application',
        },
        {
          id: 3,
          link: 'https://github.com/giwi97/citybank',
          src: require('@/assets/project3.jpg'),
          desc: 'Simple standalone Banking System',
        },
        {
          id: 4,
          link: 'https://github.com/giwi97?tab=repositories',
          src: require('@/assets/project4.jpg'),
          desc: 'Click to Find More Projects..',
        },
      ],
    }),
  }
</script>
<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>
